<div class="filter" (click)="opemModal()" [ngClass]="{'selected': selected}">
    <span>
        {{name}}
        <label *ngIf="lenght != 0">({{lenght}})</label>
    </span>
    <mat-icon aria-hidden="false" aria-label="Menu apps">arrow_drop_down</mat-icon> 
</div>